module.exports = __webpack_public_path__ + "img/petsa-elec-plo.f34baada.png";